import React from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import { reduxForm, Field } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
// import PropTypes from 'prop-types';
import { buttonsApp } from '../../styles/GeneralStyles';
import { history } from '../../helpers/history';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
const EstadoCivil = [
    {
        "Codigo": "C",
        "Nombre": "Casado"
    },
    {
        "Codigo": "X",
        "Nombre": "Casado con disolución conyugal"
    },
    {
        "Codigo": "D",
        "Nombre": "Divorciado"
    },
    {
        "Codigo": "S",
        "Nombre": "Soltero"
    },
    {
        "Codigo": "U",
        "Nombre": "Union Libre"
    },
    {
        "Codigo": "V",
        "Nombre": "Viudo"
    }
]
const validate = values => {
    const error = {}
    if (!values.amount) {
        error.amount = "Campo obligatorio "
    }
    if (!values.expenses) {
        error.expenses = "Campo obligatorio "
    }
    return error
}
const ChargeInfoCustomer = props => {
    const { user, handleSubmit, valid } = props
    const classes = buttonsApp()
    return (
        <div>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={3} justifyContent="center" alignItems="center">
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Typography style={{ color: '#2E2757', }} >
                            {`Verifica tu información personal y actualizada según corresponda`}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Typography style={{ color: '#2E2757', }} >
                            {`Dirección del domicilio actual`}
                        </Typography>
                        <Typography style={{ }} >
                            {user.direccion}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Typography style={{ color: '#2E2757', }} >
                            {`Tipo de Vivienda`}
                        </Typography>
                        <Typography style={{ }} >
                            {'CASA'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Typography style={{ color: '#2E2757', }} >
                            {`Numero teléfono fijo`}
                        </Typography>
                        <Typography style={{ }} >
                            {user.telefono}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Typography style={{ color: '#2E2757', }} >
                            {`Ingresos (Sueldo o negocio)`}
                        </Typography>
                        {/* <Typography style={{ }} >
                            ${1500}
                        </Typography> */}
                        <Field
                            name="amount"
                            type={'number'}
                            // defaultValue= {'400'}
                            id="amount"
                            component={RenderTextFieldRedux}
                            label="Ingresos (Sueldo o negocio)"
                            fullWidth
                            simbol='$'
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Typography style={{ color: '#2E2757', }} >
                            {`Gastos (Familiares)`}
                        </Typography>
                        {/* <Typography style={{ }} >
                            ${500}
                        </Typography> */}
                        <Field
                            name="expenses"
                            type={'number'}
                            id="expenses"
                            // defaultValue= {'400'}
                            component={RenderTextFieldRedux}
                            label="Gastos (Familiares)"
                            fullWidth
                            simbol='$'
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Typography style={{ color: '#2E2757', }} >
                            {`Estado Civil`}
                        </Typography>
                        <Typography style={{ }} >
                            {/* {console.log(EstadoCivil)}
                            {console.log(user)}
                            {console.log(EstadoCivil.filter(ec => ec.Codigo === user.codigoEstadoCivil)[0].Nombre)} */}
                            {(EstadoCivil.filter(ec => ec.Codigo === user.codigoEstadoCivil)[0].Nombre).toString()}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} xl={6}>
                        <Button variant="contained" type="submit"
                            fullWidth
                            style={{ height: '100%' }}
                            className={classes.buttonStandard}
                            disabled={!valid}
                        >
                            Continuar
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} xl={6}>
                        <Button variant="contained" onClick={() => history.push('/')}
                            fullWidth
                            style={{ height: '100%' }}
                            className={classes.buttonStandard}
                        // disabled={invalid }
                        >
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
};

ChargeInfoCustomer.propTypes = {

};
const ChargeInfoCustomerReduxForm = reduxForm(
    {
        form: 'ChargeInfoCustomer',
        validate,
        destroyOnUnmount: false
    }
)(ChargeInfoCustomer)

export default setPropsAsInitial(ChargeInfoCustomerReduxForm);